<template>
    <div class="sidebar-container">
      <div class="collapse-button">
        <zm-button type="icon" icon="zm-icon-forward" v-if="isCollapse" @click="isCollapse = !isCollapse"></zm-button>
        <zm-button type="icon" icon="zm-icon-backward" v-if="!isCollapse" @click="isCollapse = !isCollapse"></zm-button>
      </div>
      <zm-menu
        :default-active="$route.path"
        class="zm-menu-vertical-demo"
        router
        :collapse="isCollapse">
        <zm-submenu index="/dashboard/index">
            <template slot="title">
              <i class="iconfont icon-dashboard"></i>
              <span slot="title">Dashboard</span>
            </template>
            <zm-menu-item index="/dashboard/index">Dashboard</zm-menu-item>
            <zm-menu-item index="/dashboard/monitor">Monitor</zm-menu-item>
          </zm-submenu>
          <zm-menu-item index="/dashboard/datacenter">
            <i class="iconfont icon-data"></i>
            <span slot="title">Data Center</span>
          </zm-menu-item>
          <zm-menu-item index="/dashboard/request" v-if="role !== 'READONLY'">
            <i class="iconfont icon-task"></i>
            <span slot="title">Request</span>
          </zm-menu-item>
          <zm-menu-item index="/dashboard/user" v-if="hasPermission || role === 'REVIEWER'">
            <i class="iconfont icon-UserSettings"></i>
            <span slot="title">User</span>
          </zm-menu-item>
          <zm-submenu index="/dashboard/topic">
            <template slot="title">
              <i class="iconfont icon-topic"></i>
              <span slot="title">Topic</span>
            </template>
            <zm-menu-item index="/dashboard/topic">Topic</zm-menu-item>
            <zm-menu-item index="/dashboard/collection">Topic Collection</zm-menu-item>
            <zm-menu-item index="/dashboard/migratingTopic">Topic Migration</zm-menu-item>
          </zm-submenu>
          <zm-menu-item index="/dashboard/clientMap">
            <i class="iconfont icon-clientlist"></i>
            <span slot="title">Client Map</span>
          </zm-menu-item>
          <zm-submenu index="/dashboard/task">
            <template slot="title">
              <i class="iconfont icon-task"></i>
              <span slot="title">Task</span>
            </template>
            <zm-menu-item index="/dashboard/task">Task</zm-menu-item>
            <zm-menu-item index="/dashboard/trigger">Batch Trigger</zm-menu-item>
            <zm-menu-item index="/dashboard/longTask">Long Task</zm-menu-item>
          </zm-submenu>
          <zm-menu-item index="/dashboard/job">
            <i class="iconfont icon-jobtitle"></i>
            <span slot="title">Job</span>
          </zm-menu-item>
          <zm-menu-item index="/dashboard/agent">
            <i class="iconfont icon-configuration"></i>
            <span slot="title">Agent</span>
          </zm-menu-item>
          <zm-submenu index="/dashboard/channel" v-if="hasPermission || role === 'REVIEWER'">
            <template slot="title">
              <i class="iconfont icon-channel"></i>
              <span slot="title">{{ channelName }}</span>
            </template>
            <zm-menu-item index="/dashboard/channel">{{ channelName }}</zm-menu-item>
            <zm-menu-item index="/dashboard/sentinel">Sentinel</zm-menu-item>
          </zm-submenu>
          <zm-submenu index="/dashboard/zk">
            <template slot="title">
              <i class="iconfont icon-Generateclientoffer"></i>
              <span slot="title">Settings</span>
            </template>
            <zm-menu-item index="/dashboard/status">Status</zm-menu-item>
            <zm-menu-item index="/dashboard/zk">ZK</zm-menu-item>
            <zm-menu-item index="/dashboard/auditlog">Audit Log</zm-menu-item>
            <zm-menu-item index="/dashboard/client">Client Param</zm-menu-item>
            <zm-menu-item index="/dashboard/map">Map</zm-menu-item>
            <zm-menu-item index="/dashboard/group">Global Config</zm-menu-item>
            <zm-menu-item index="/dashboard/webhook">Webhook</zm-menu-item>
            <zm-menu-item index="/dashboard/topicalert">Topic Alert</zm-menu-item>
            <zm-menu-item index="/dashboard/document">Document</zm-menu-item>
            <zm-menu-item index="/dashboard/monitorManage/notificationChannel">MonitorManage</zm-menu-item>
            <zm-menu-item index="/dashboard/smart">Task Handler Platform</zm-menu-item>
            <zm-menu-item index="/dashboard/permission/menu">RBAC</zm-menu-item>
          </zm-submenu>
          <zm-submenu index="/dashboard/kafkaManage">
            <template slot="title">
              <i class="iconfont icon-configuration"></i>
              <span slot="title">Kafka Manage</span>
            </template>
            <zm-menu-item index="/dashboard/manage/dashboard">Dashboard</zm-menu-item>
            <zm-menu-item index="/dashboard/manage/cluster">Cluster</zm-menu-item>
            <zm-menu-item index="/dashboard/manage/alert">Alert</zm-menu-item>
            <zm-menu-item index="/dashboard/manage/reassign">Reassign</zm-menu-item>
            <zm-menu-item index="/dashboard/manage/webhook">Webhook</zm-menu-item>
            <zm-menu-item index="/dashboard/manage/cube">Cube Monitor</zm-menu-item>
          </zm-submenu>
      </zm-menu>
    </div>
</template>
<script>
import { getMqType } from 'api/index'
export default {
    name: 'sidebar',
    data () {
      return {
        role: localStorage.role,
        hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
        channelName: '',
        isCollapse: true
      }
    },
    watch: {
      isCollapse () {
        localStorage.isCollapse = this.isCollapse
      }
    },
    created () {
      this.isCollapse = localStorage.isCollapse === 'true'
      getMqType().then(response => {
        this.channelName = response
      })
    },
    methods: {
    }
}
</script>
<style>
@import '../../../assets/icons/iconfont.css';
.sidebar-container {
    float: left;
    margin-right: -170px;
    /* border-right: 1px solid #d8dce5; */
    border-top: 1px solid #d8dce5;
    margin-top: 60px;
}
.zm-menu-vertical-demo:not(.zm-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.zm-menu-vertical-demo {
  height: 100%;
}
.collapse-button {
  border-right: 1px solid #d8dce5;
  padding: 10px;
}
.zm-menu-item {
  height: 43px;
  line-height: 45px;
  font-size: 14px;
}
.zm-submenu__title {
  height: 43px;
  line-height: 45px;
  font-size: 14px;
}
.zm-submenu .zm-menu-item {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
.iconfont {
  margin-right: 10px;
}
.zm-menu--vertical {
  top: 400px;
}
</style>
